// extracted by mini-css-extract-plugin
export var arrow = "_bw-1";
export var content = "_bw-0";
export var highlighted = "_bw-2";